import * as angular from 'angular';

export class DATES {
    public readonly DATETIME_DEFAULT: 'dd.MM.yyyy HH:mm' = 'dd.MM.yyyy HH:mm';
    public readonly DATETIME_ACTIVITY: 'dd/MM/yyyy HH:mm' = 'dd/MM/yyyy HH:mm';
    public readonly DATETIME_DEBUG: 'dd.MM.yyyy HH:mm:ss' =
        'dd.MM.yyyy HH:mm:ss';
    public readonly DATE_DEFAULT: 'dd.MM.yyyy' = 'dd.MM.yyyy';
    public readonly TIME_DEFAULT: 'HH:mm' = 'HH:mm';
    public readonly YEAR: 'yyyy' = 'yyyy';
    public readonly MONTH: 'M' = 'M';
    public readonly MONTH_YEAR: 'MM.yyyy' = 'MM.yyyy';
    public readonly DAY_MONTH_TIME: 'dd.MM HH:mm' = 'dd.MM HH:mm';
    public readonly DAY_MONTH: 'dd.MM' = 'dd.MM';
}

angular.module('app').constant('DATES', {
    DATETIME_DEFAULT: new DATES().DATETIME_DEFAULT,
    DATETIME_ACTIVITY: new DATES().DATETIME_ACTIVITY,
    DATETIME_DEBUG: new DATES().DATETIME_DEBUG,
    DATE_DEFAULT: new DATES().DATE_DEFAULT,
    TIME_DEFAULT: new DATES().TIME_DEFAULT,
    YEAR: new DATES().YEAR,
    MONTH: new DATES().MONTH,
    MONTH_YEAR: new DATES().MONTH_YEAR,
    DAY_MONTH_TIME: new DATES().DAY_MONTH_TIME,
    DAY_MONTH: new DATES().DAY_MONTH
});
